import {
  CatalogueItem,
  NewsItem,
  Associate,
  HomePageCarouselItem,
  BlogPost,
  BlogCategory,
} from "../services/models";

export const newsItems: NewsItem[] = [
  {
    id: 1,
    link: "https://ffm.to/ava-die4you",
    imgSrc: "assets/img/news/Ava-square-die4y.jpg",
    date: "MARCH 2023",
    title:
      "Ava in the Dark release new single 'Die 4 You' with 7WestMusic + LabRecords",
    description:
      "Aired on Radio 1 Introducing Rock Show with Alyx Holcombe, playlisted on AppleMusic's 'New in Indie' worldwide",
  },
  {
    id: 2,
    link: "https://youthmusic.org.uk/original-track-award-group-22",
    imgSrc: "assets/img/news/YouthMusicAward-ava.png",
    date: "OCT 2022",
    title:
      "'Manic' - Ava in the Dark wins YouthMusic Award for Best Original Track (group) sponsored by Marshall Amps",
    description: "This release was made possible with support from Launchpad.",
  },
  {
    id: 3,
    link: "#",
    imgSrc: "assets/img/news/AmazonsClips.mp4",
    date: "OCT 2022",
    title: "Ava in the Dark supporting The Amazons on their UK Tour",
    description: "Part of BBC Music Introducing partnership",
  },
  {
    id: 3,
    link: "#",
    imgSrc: "https://www.facebook.com/focuswales/videos/740391110469736/",
    date: "MAY 2022",
    title: "Ava in the Dark at FOCUS WALES 2022",
    description:
      "Delete Us Forever was used as the background music for FOCUS Wales' highlights vid",
  },
  {
    id: 4,
    link: "https://youthmusic.org.uk/original-track-award-group-22",
    imgSrc: "assets/img/news/YouthMusicAward-ava.png",
    date: "OCT 2022",
    title:
      "'Manic' - Ava in the Dark wins YouthMusic Award for Best Original Track (group) sponsored by Marshall Amps",
    description: "This release was made possible with support from Launchpad.",
  },
  {
    id: 5,
    link: "#",
    imgSrc: "assets/img/news/AmazonsClips.mp4",
    date: "OCT 2022",
    title: "Ava in the Dark supporting The Amazons on their UK Tour",
    description: "Part of BBC Music Introducing partnership",
  },
  {
    id: 6,
    link: "#",
    imgSrc: "https://www.facebook.com/focuswales/videos/740391110469736/",
    date: "MAY 2022",
    title: "Ava in the Dark at FOCUS WALES 2022",
    description:
      "Delete Us Forever was used as the background music for FOCUS Wales' highlights vid",
  },
];

export const blogs: BlogPost[] = [
  {
    id: 1,
    title: "Favourite Underground Indie Rock/Pop Releases of 2024 from Leeds",
    description:
      "A roundup of the best underground indie rock and pop releases from Leeds in 2024.",
    thumbnailImgSrc:
      "https://mosaic.scdn.co/300/ab67616d00001e0236f53d4cc26e3e4f98721911ab67616d00001e028dd6ca1b17e348e24715f603ab67616d00001e02948915707cd71e1465649b90ab67616d00001e02fc808bcea1684e202754d251",
    thumbnailAltText: "Underground Indie Rock Releases 2024",
    thumbnailVidSrc: null,
    contentPath: "/blogs/1.md",
    publishDate: new Date("2025-01-06"),
    author: "Tommie James",
    visible: true,
    category: [BlogCategory.REVIEWS, BlogCategory.RELEASES],
  },
  {
    id: 2,
    title:
      "Why Are Smaller Artists Risking More Than the Giants to Oppose Genocide?",
    description:
      "A scathing look at why independent artists are taking louder, riskier stands against Israel's war on Gaza while major artists stay silent—or complicit.",
    thumbnailImgSrc:
      "https://upload.wikimedia.org/wikipedia/commons/7/75/Free_Palestine_graffiti_in_Bethlehem.jpg",
    thumbnailAltText: "Free Palestine graffiti in Bethlehem",
    thumbnailVidSrc: null,
    contentPath: "/blogs/2.md",
    publishDate: new Date("2025-06-06"),
    author: "Tommie James",
    visible: true,
    category: [BlogCategory.NEWS],
  },
];

export const releases: CatalogueItem[] = [
  {
    id: 1,
    name: "Delete Us Forever EP",
    imgSrc: "",
    artist: "Ava in the Dark",
    date: "March 2020",
    contribution: "Recording, Production, Mixing, Mastering, PR",
    description:
      "BBC6 Radio play for 'Still', BBC Radio Wales A-List for 2 weeks for 'Delete Us Forever'",
  },
  {
    id: 2,
    name: "Affections",
    imgSrc: "",
    artist: "",
    date: "bleh",
    contribution: "",
    description: "",
  },
  {
    id: 3,
    name: "Product 3",
    imgSrc: "",
    artist: "",
    date: "bleh",
    contribution: "",
    description: "",
  },
  {
    id: 4,
    name: "Product 4",
    imgSrc: "",
    artist: "",
    date: "bleh",
    contribution: "",
    description: "",
  },
  {
    id: 5,
    name: "Product 5",
    imgSrc: "",
    artist: "",
    date: "bleh",
    contribution: "",
    description: "",
  },
  {
    id: 6,
    name: "Product 6",
    imgSrc: "",
    artist: "",
    date: "bleh",
    contribution: "",
    description: "",
  },
];

export const associates: Associate[] = [
  {
    id: 1,
    name: "Steve",
    thumbnailImgSrc: "",
    URL: "",
    artists: [],
    description: "steve description",
  },
];

export const homePageCarouselItems: HomePageCarouselItem[] = [
  {
    id: 1,
    title: "Spread the Message",
    caption: "A hand-curated list of artists to support",
    imageSrcURL: "assets/img/artists/ava-in-the-dark.jpeg",
    linkURL: "/associates",
    active: true,
    altText: "spread the message slide",
  },
  {
    id: 2,
    title: "Submit your music",
    caption:
      "we're looking to work with more artists in Leeds, send us a link!",
    imageSrcURL: "assets/img/artists/ava-in-the-dark.jpeg",
    linkURL: "//MusicSubmission",
    active: true,
    altText: "submit your music slide",
  },
];
export { BlogCategory };
